export const kanban = {
  page: {
    kicker: 'Workspace',
    title: 'Deliverables & team board',
    subtitle:
      'Plan the week, track what is in flight and keep the monthly deliverables in sight.',
  },
  monthChips: {
    kicker: 'This month',
  },
  columns: {
    backlog: 'Backlog',
    thisWeek: 'This week',
    inProgress: 'In progress',
    inReview: 'In review',
    done: 'Done',
    empty: 'No tasks here yet',
  },
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High',
  },
  quickAdd: {
    cta: 'Add task',
    placeholder: 'What needs to happen?',
    hint: 'Press enter to create · esc to cancel',
  },
  filters: {
    searchPlaceholder: 'Search tasks, tags, descriptions…',
    priority: {
      all: 'All priorities',
    },
    clear: 'Clear filters',
  },
  drawer: {
    title: 'Edit task',
    createdAt: 'Created {{date}}',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    fields: {
      title: 'Title',
      description: 'Description',
      status: 'Status',
      priority: 'Priority',
      dueDate: 'Due date',
      tags: 'Tags',
      tagsPlaceholder: 'Comma-separated (blog, seo, …)',
      linkedDeliverable: 'Linked deliverable',
      linkedDeliverablePlaceholder: 'e.g. blog, landing, video',
      assignee: 'Assignee',
    },
  },
} as const
